import { getVideoJsComponent } from "./utils";

import type { THEOPlayerRuntime } from "./theoplayerRuntime";
import type Player from "video.js/dist/types/player";

export const getFullscreenCommentButton = (runtime: THEOPlayerRuntime) => {
  const Button = getVideoJsComponent("Button", runtime);

  class FullscreenCommentButton extends Button {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    handleClick() {
      const target = document.getElementById("fullscreen-streaming-comment");
      if (target) {
        if (target.style.display === "none") {
          target.style.display = "flex";
        } else {
          target.style.display = "none";
        }
      }
    }

    createEl() {
      const commentIcon = `
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M26 8H10C8.9 8 8 8.9 8 10V28L12 24H26C27.1 24 28 23.1 28 22V10C28 8.9 27.1 8 26 8ZM26 22H12L10 24V10H26V22Z" fill="white"/>
      </svg>
    `;

      const el = super.createEl("button", {
        className:
          "vjs-custom-fullscreen-comment-button vjs-custom-button vjs-control vjs-button",
        innerHTML: `
      ${commentIcon}
        <span class="vjs-control-text">フルスクリーンコメント</span>
      `,
        title: "Fullscreen comment",
      });
      return el;
    }
  }

  return FullscreenCommentButton;
};
